/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response from Azure tenant discovery
 * @export
 * @interface AzureTenantDiscoveryResponse
 */
export interface AzureTenantDiscoveryResponse {
    /**
     * Whether discovery was successful
     * @type {boolean}
     * @memberof AzureTenantDiscoveryResponse
     */
    success?: boolean;
    /**
     * Discovered Azure AD tenant ID
     * @type {string}
     * @memberof AzureTenantDiscoveryResponse
     */
    tenantId?: string;
    /**
     * Azure cloud environment where tenant was found
     * @type {string}
     * @memberof AzureTenantDiscoveryResponse
     */
    cloud?: AzureTenantDiscoveryResponseCloudEnum;
    /**
     * List of all cloud environments where tenant was discovered
     * @type {Array<string>}
     * @memberof AzureTenantDiscoveryResponse
     */
    discoveredClouds?: Array<string>;
    /**
     * Error message if discovery failed
     * @type {string}
     * @memberof AzureTenantDiscoveryResponse
     */
    error?: string;
    /**
     * Domain that was queried
     * @type {string}
     * @memberof AzureTenantDiscoveryResponse
     */
    domain?: string;
}


/**
 * @export
 */
export const AzureTenantDiscoveryResponseCloudEnum = {
    Com: 'com',
    Us: 'us',
    Cn: 'cn',
    De: 'de'
} as const;
export type AzureTenantDiscoveryResponseCloudEnum = typeof AzureTenantDiscoveryResponseCloudEnum[keyof typeof AzureTenantDiscoveryResponseCloudEnum];


/**
 * Check if a given object implements the AzureTenantDiscoveryResponse interface.
 */
export function instanceOfAzureTenantDiscoveryResponse(value: object): value is AzureTenantDiscoveryResponse {
    return true;
}

export function AzureTenantDiscoveryResponseFromJSON(json: any): AzureTenantDiscoveryResponse {
    return AzureTenantDiscoveryResponseFromJSONTyped(json, false);
}

export function AzureTenantDiscoveryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AzureTenantDiscoveryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'cloud': json['cloud'] == null ? undefined : json['cloud'],
        'discoveredClouds': json['discoveredClouds'] == null ? undefined : json['discoveredClouds'],
        'error': json['error'] == null ? undefined : json['error'],
        'domain': json['domain'] == null ? undefined : json['domain'],
    };
}

export function AzureTenantDiscoveryResponseToJSON(json: any): AzureTenantDiscoveryResponse {
    return AzureTenantDiscoveryResponseToJSONTyped(json, false);
}

export function AzureTenantDiscoveryResponseToJSONTyped(value?: AzureTenantDiscoveryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'tenantId': value['tenantId'],
        'cloud': value['cloud'],
        'discoveredClouds': value['discoveredClouds'],
        'error': value['error'],
        'domain': value['domain'],
    };
}

